import Destruct from "../components/images/Destruction.png";
import "../App.css";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import * as bootstrap from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import RUG from "react-upload-gallery";
import axios from "axios";
import "./thankYou";
import "./Error";
import { getEnv } from "../helpers/Config";
import { Axios } from "../axios/Axios";
import ReactGA from "react-ga";
import "react-upload-gallery/dist/style.css";
const TRACKING_ID = "UA-5168202-7";
ReactGA.initialize(TRACKING_ID);

export const Home = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  useEffect(() => {
    var ip;

    //creating function to load ip address from the API
    axios({
      method: "get",
      url: "https://api.ipify.org/?format=json",
    })
      .then((response) => {
        ip = response.data.ip;

        axios({
          method: "get",
          url:
            url + "/verification/SiteAvailability?id=" + siteId + "&&ip=" + ip,
        })
          .then((response) => {
            if (!response.data) {
              navigate("/Construction", { replace: true });
            }
          })
          .catch((response) => {
            navigate("/Error", { replace: true });
          });
      })
      .catch((response) => {
        console.log("IP address retrieval failure");
      });
  }, []);

  let navigate = useNavigate();
  const siteId = 49;
  let url = getEnv();
  const { t, i18n } = useTranslation();
  const {
    register,
    handleSubmit,
    getValues,
    watch,
    trigger,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
  });
  const handleInputChange = (event) => {
    if (event && event.length > 0) {
      let files = event[0].file;
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = (e) => {
        setImages(reader.result);
      };
      setImageValid(true);
    } else {
      setImageValid(false);
    }
  };
  const onSubmit = (data) => {
    setIsSubmitting(true);
    const imagesArray = images.split(",");
    let SFDFI = [
      {
        DynamicFieldId: 33504,
        FieldValue: data.address,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33512,
        FieldValue: data.city,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33513,
        // FieldValue: data.country,
        FieldValue: "US",
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33508,
        FieldValue: data.email,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33502,
        FieldValue: data.firstName,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33503,
        FieldValue: data.lastName,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33515,
        FieldValue: data.postalCode,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33514,
        FieldValue: data.state,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33507,
        FieldValue: data.phoneNumber,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      // Site Specific Fields
      {
        DynamicFieldId: 67636,
        FieldValue: data.wherePurchased,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67637,
        FieldValue: imagesArray[1],
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67634,
        FieldValue: data.wallType,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
    ];
    if (data.address2) {
      SFDFI.push({
        DynamicFieldId: 33506,
        FieldValue: data.address2,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.confirm === "No") {
      SFDFI.push({
        DynamicFieldId: 60390,
        FieldValue: data.attentionTo,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    } else {
      SFDFI.push({
        DynamicFieldId: 60390,
        FieldValue: data.firstName + " " + data.lastName,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (watchWallType !== "Not Installed") {
      SFDFI.push({
        DynamicFieldId: 67635,
        FieldValue: data.whoInstalled,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.professionalPhone) {
      SFDFI.push({
        DynamicFieldId: 67644,
        FieldValue: data.professionalPhone,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.professionalFirstName) {
      SFDFI.push({
        DynamicFieldId: 67642,
        FieldValue: data.professionalFirstName,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.professionalLastName) {
      SFDFI.push({
        DynamicFieldId: 67643,
        FieldValue: data.professionalLastName,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.wherePurchasedOther) {
      SFDFI.push({
        DynamicFieldId: 67640,
        FieldValue: data.wherePurchasedOther,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.whoInstalledOther) {
      SFDFI.push({
        DynamicFieldId: 67639,
        FieldValue: data.whoInstalledOther,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.wallTypeOther) {
      SFDFI.push({
        DynamicFieldId: 67638,
        FieldValue: data.wallTypeOther,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }

    // console.log(data);
    var SimpleSuperFormDTO = {
      FormInstances: {
        DefinitionId: 493,
        CompanyId: 116,
        CreatedBy: 803,
        CreatedFor: 803,
        WorkTypeItemId: 3507,
        WorkFlowOverallStatusId: 1,
        WorkflowId: 1,
        Source: 3,
        InstanceID: 0,
      },
      DynamicFieldslist: SFDFI,
    };
    SimpleSuperFormDTO.FormInstances.CreatedDate = new Date();
    //console.log(SimpleSuperFormDTO);
    axios({
      method: "post",
      url: url + "/SuperForm/SaveSimpleSuperForm",
      data: SimpleSuperFormDTO,
    })
      .then((response) => {
        console.log("success");
        Axios.email(data, response.data.formInstances.instanceId);
        navigate("/thankYou", {
          state: { id: response.data.formInstances.instanceId },
          replace: true,
        });
      })
      .catch((response) => {
        console.log("fail");
        navigate("/Error", { replace: true });
      });
  };

  console.log(errors);

  const [images, setImages] = useState([]);
  const [imageValid, setImageValid] = useState(true);
  const [showPage, setShowPage] = useState(1);
  const [addressValid, setAddressValid] = useState(true);
  const [byPassCheck, setByPassCheck] = useState(false);

  const watchConfirm = watch("confirm", null); // you can supply default value as second argument
  const watchWallType = watch("wallType", null); // you can supply default value as second argument
  const watchWhoinstalled = watch("whoInstalled", null); // you can supply default value as second argument
  const watchWherePurchased = watch("wherePurchased", null); // you can supply default value as second argument

  return (
    <div>
      <bootstrap.Form onSubmit={handleSubmit(onSubmit)}>
        <bootstrap.Container fluid>
          <bootstrap.Row>
            <bootstrap.Col>
              <p className="lead">
                This is the online registration form for the Cyme Tech recall of
                certain full-sized and queen-sized Murphy beds sold online under
                the brand names "Ivy Bronx," "Orren Ellis," "Stellar Home
                Furniture," and "Wade Logan". To read the complete CPSC Press
                Release click{" "}
                <a
                  href="https://www.cpsc.gov/Recalls/2022/Murphy-Beds-Recalled-Due-to-Serious-Impact-and-Crush-Hazards-Manufactured-by-Cyme-Tech-Recall-Alert"
                  target="_blank"
                >
                  here.{" "}
                </a>
              </p>
              <p className="lead">
                If you have a Murphy bed subject to this recall, please complete
                the form below so that we may inspect and complete the repair of
                your bed at no cost to you. Please note that to complete your
                registration you will need a copy of your purchase receipt which
                can be obtained by logging in to the ecommerce site where you
                purchased the bed.
              </p>
              <p className="lead">
                If you need assistance, please contact a representative at
                1-800-320-7096 between 8:30 a.m. and 6:00 p.m. (Eastern Time)
                Monday through Friday.
              </p>
            </bootstrap.Col>
          </bootstrap.Row>
          <bootstrap.Card className="border-custom">
            <bootstrap.Card.Header>
              <p className="lead fw-bold">Customer Information:</p>
            </bootstrap.Card.Header>
            <bootstrap.Card.Body>
              <p className="lead fw-bold">
                Please fill out your information below.
              </p>
              <bootstrap.Row>
                <bootstrap.Col>
                  {/* First Name */}
                  <bootstrap.Form.Label htmlFor="firstName" className="lead">
                    First Name
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Control
                      type="text"
                      // placeholder={t("step2.firstName")}
                      id="firstName"
                      {...register("firstName", {
                        required: true,
                        maxLength: 80,
                      })}
                    />{" "}
                  </bootstrap.InputGroup>
                  {errors.firstName && (
                    <bootstrap.Alert variant="danger" className="text-center">
                      Required
                    </bootstrap.Alert>
                  )}
                </bootstrap.Col>
                <bootstrap.Col>
                  {/* Last Name */}
                  <bootstrap.Form.Label htmlFor="lastName" className="lead">
                    Last Name
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Control
                      type="text"
                      //placeholder={t("step2.lastName")}
                      id="lastName"
                      {...register("lastName", {
                        required: true,
                        maxLength: 100,
                      })}
                    />
                  </bootstrap.InputGroup>
                  {errors.lastName && (
                    <bootstrap.Alert variant="danger" className="text-center">
                      Required
                    </bootstrap.Alert>
                  )}
                </bootstrap.Col>
              </bootstrap.Row>
              <bootstrap.Row>
                <bootstrap.Col>
                  {/* Adress Line 1 */}
                  <bootstrap.Form.Label htmlFor="address" className="lead">
                    Address Line 1
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Control
                      type="text"
                      id="address"
                      {...register("address", { required: true })}
                    />
                  </bootstrap.InputGroup>
                  {errors.address && (
                    <bootstrap.Alert variant="danger" className="text-center">
                      Required
                    </bootstrap.Alert>
                  )}{" "}
                </bootstrap.Col>
              </bootstrap.Row>
              <bootstrap.Row>
                <bootstrap.Col>
                  {/* Address 2 */}
                  <bootstrap.Form.Label htmlFor="address2" className="lead">
                    Address Line 2
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Control
                      type="text"
                      //placeholder={t("step2.lastName")}
                      id="address2"
                      {...register("address2", {})}
                    />
                  </bootstrap.InputGroup>
                  {errors.address2 && (
                    <bootstrap.Alert variant="danger" className="text-center">
                      Required
                    </bootstrap.Alert>
                  )}
                </bootstrap.Col>
              </bootstrap.Row>
              <bootstrap.Row>
                <bootstrap.Col>
                  {" "}
                  {/* City */}
                  <bootstrap.Form.Label htmlFor="city" className="lead">
                    City
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Control
                      type="text"
                      //placeholder={t("step2.email")}
                      id="city"
                      {...register("city", { required: true })}
                    />
                  </bootstrap.InputGroup>
                  {errors.city && (
                    <bootstrap.Alert variant="danger" className="text-center">
                      Required
                    </bootstrap.Alert>
                  )}
                </bootstrap.Col>
                <bootstrap.Col>
                  {/* State */}
                  <bootstrap.Form.Label htmlFor="state" className="lead">
                    State
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Select
                      className="text-center"
                      aria-label="Default State Label"
                      id="state"
                      {...register("state", { required: true })}
                    >
                      <option value="">--Please Select--</option>
                      <option value="AL">Alabama</option>
                      <option value="AK">Alaska</option>
                      <option value="AZ">Arizona</option>
                      <option value="AR">Arkansas</option>
                      <option value="CA">California</option>
                      <option value="CO">Colorado</option>
                      <option value="CT">Connecticut</option>
                      <option value="DE">Delaware</option>
                      <option value="DC">District of Columbia</option>
                      <option value="FL">Florida</option>
                      <option value="GA">Georgia</option>
                      <option value="HI">Hawaii</option>
                      <option value="ID">Idaho</option>
                      <option value="IL">Illinois</option>
                      <option value="IN">Indiana</option>
                      <option value="IA">Iowa</option>
                      <option value="KS">Kansas</option>
                      <option value="KY">Kentucky</option>
                      <option value="LA">Louisiana</option>
                      <option value="ME">Maine</option>
                      <option value="MD">Maryland</option>
                      <option value="MA">Massachusetts</option>
                      <option value="MI">Michigan</option>
                      <option value="MN">Minnesota</option>
                      <option value="MS">Mississippi</option>
                      <option value="MO">Missouri</option>
                      <option value="MT">Montana</option>
                      <option value="NE">Nebraska</option>
                      <option value="NV">Nevada</option>
                      <option value="NH">New Hampshire</option>
                      <option value="NJ">New Jersey</option>
                      <option value="NM">New Mexico</option>
                      <option value="NY">New York</option>
                      <option value="NC">North Carolina</option>
                      <option value="ND">North Dakota</option>
                      <option value="OH">Ohio</option>
                      <option value="OK">Oklahoma</option>
                      <option value="OR">Oregon</option>
                      <option value="PA">Pennsylvania</option>
                      <option value="RI">Rhode Island</option>
                      <option value="SC">South Carolina</option>
                      <option value="SD">South Dakota</option>
                      <option value="TN">Tennessee</option>
                      <option value="TX">Texas</option>
                      <option value="UT">Utah</option>
                      <option value="VT">Vermont</option>
                      <option value="VA">Virginia</option>
                      <option value="WA">Washington</option>
                      <option value="WV">West Virginia</option>
                      <option value="WI">Wisconsin</option>
                      <option value="WY">Wyoming</option>
                      <option value="AA">Armed Forces Americas</option>
                      <option value="AE">Armed Forces Canada</option>
                      <option value="AP">Armed Forces Pacific</option>
                      <option value="PR">Puerto Rico</option>
                    </bootstrap.Form.Select>
                  </bootstrap.InputGroup>
                  {errors.state && (
                    <bootstrap.Alert variant="danger" className="text-center">
                      Required
                    </bootstrap.Alert>
                  )}
                </bootstrap.Col>
                <bootstrap.Col>
                  {" "}
                  {/* Postal */}
                  <bootstrap.Form.Label htmlFor="postal" className="lead">
                    Zip Code
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Control
                      type="text"
                      //placeholder="XXXXXXXXXX"
                      id="postal"
                      {...register("postalCode", {
                        required: true,
                        min: 5,
                        pattern: /\d{5}(-\d{4})?/i,
                      })}
                    />
                  </bootstrap.InputGroup>
                  {errors.postalCode && (
                    <bootstrap.Alert variant="danger" className="text-center">
                      Required
                    </bootstrap.Alert>
                  )}
                </bootstrap.Col>
              </bootstrap.Row>
              <bootstrap.Row>
                <bootstrap.Col>
                  {" "}
                  {/* Phone */}
                  <bootstrap.Form.Label htmlFor="phone" className="lead">
                    Phone
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Control
                      type="tel"
                      placeholder="XXXXXXXXXX"
                      id="phone"
                      {...register("phoneNumber", {
                        required: true,
                        maxLength: 10,
                        pattern: /\d{10}/i,
                      })}
                    />
                  </bootstrap.InputGroup>
                  {errors.phoneNumber && (
                    <bootstrap.Alert variant="danger" className="text-center">
                      Required
                    </bootstrap.Alert>
                  )}
                  {errors.phoneNumber &&
                    errors.phoneNumber.type === "pattern" && (
                      <bootstrap.Alert variant="danger">
                        <p className="lead text-danger text-center">
                          {t("errors.phoneFormatError")}
                        </p>
                      </bootstrap.Alert>
                    )}
                </bootstrap.Col>
              </bootstrap.Row>
              <bootstrap.Row>
                <bootstrap.Col>
                  {/* Email */}
                  <bootstrap.Form.Label htmlFor="email" className="lead">
                    Email
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Control
                      type="email"
                      //placeholder={t("step2.email")}
                      id="email"
                      aria-describedby="emailtext"
                      {...register("email", {
                        required: true,
                        pattern:
                          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      })}
                    />

                    <bootstrap.InputGroup.Text id="emailText">
                      @example.com
                    </bootstrap.InputGroup.Text>
                  </bootstrap.InputGroup>
                  {errors.email && (
                    <bootstrap.Alert variant="danger" className="text-center">
                      Required
                    </bootstrap.Alert>
                  )}
                  {errors.email && errors.email.type === "pattern" && (
                    <bootstrap.Alert variant="danger">
                      <p className="lead text-danger text-center">
                        {t("errors.emailFormatError")}
                      </p>
                    </bootstrap.Alert>
                  )}
                </bootstrap.Col>
              </bootstrap.Row>
              <bootstrap.Row>
                <bootstrap.Col>
                  {" "}
                  {/* Verify Email */}
                  <bootstrap.Form.Label htmlFor="verifyEmail" className="lead">
                    Verify Email
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Control
                      type="email"
                      //placeholder={t("step2.verifyEmail")}
                      id="verifyEmail"
                      aria-describedby="verifyEmailText"
                      {...register("verifyEmail", {
                        required: true,
                        pattern:
                          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        validate: {
                          mismatch: (value) => {
                            const { email } = getValues();
                            return email === value;
                          },
                        },
                      })}
                    />
                    <bootstrap.InputGroup.Text id="verifyEmailText">
                      @example.com
                    </bootstrap.InputGroup.Text>
                  </bootstrap.InputGroup>
                  {errors.verifyEmail &&
                    errors.verifyEmail.type === "mismatch" && (
                      <bootstrap.Alert variant="danger">
                        <p className="lead text-danger text-center">
                          {t("errors.emailMismatchError")}
                        </p>
                      </bootstrap.Alert>
                    )}
                  {errors.verifyEmail &&
                    errors.verifyEmail.type === "pattern" && (
                      <bootstrap.Alert variant="danger">
                        <p className="lead text-danger text-center">
                          {t("errors.emailFormatError")}
                        </p>
                      </bootstrap.Alert>
                    )}
                  {errors.verifyEmail && (
                    <bootstrap.Alert variant="danger" className="text-center">
                      Required
                    </bootstrap.Alert>
                  )}
                </bootstrap.Col>
              </bootstrap.Row>{" "}
              <bootstrap.Row>
                <bootstrap.Col>
                  {/* Where Purchased */}
                  <bootstrap.Form.Label
                    htmlFor="wherePurchased"
                    className="lead"
                  >
                    Where did you purchase bed from?
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Select
                      className="text-center"
                      id="wherePurchased"
                      {...register("wherePurchased", { required: true })}
                    >
                      <option value="">Please Select</option>
                      <option value="Wayfair">Wayfair</option>
                      <option value="Overstock">Overstock</option>
                      <option value="Cymax">Cymax</option>
                      <option value="Amazon">Amazon</option>
                      <option value="All Modern">All Modern</option>
                      <option value="Wal-mart.com">Wal-mart.com</option>
                      <option value="Other">Other</option>
                    </bootstrap.Form.Select>
                  </bootstrap.InputGroup>
                  {errors.wherePurchased && (
                    <bootstrap.Alert variant="danger" className="text-center">
                      Required
                    </bootstrap.Alert>
                  )}
                  {/* Where Purchased Other */}
                  {watchWherePurchased === "Other" && (
                    <div>
                      <bootstrap.Form.Label
                        htmlFor="wherePurchasedOther"
                        className="lead"
                      >
                        Please Specify
                      </bootstrap.Form.Label>
                      <bootstrap.InputGroup className="mb-3">
                        <bootstrap.Form.Control
                          type="text"
                          id="wherePurchasedOther"
                          {...register("wherePurchasedOther", {
                            required: true,
                          })}
                        />
                      </bootstrap.InputGroup>
                      {errors.wherePurchasedOther && (
                        <bootstrap.Alert
                          variant="danger"
                          className="text-center"
                        >
                          Required
                        </bootstrap.Alert>
                      )}
                    </div>
                  )}
                </bootstrap.Col>
              </bootstrap.Row>
            </bootstrap.Card.Body>
          </bootstrap.Card>

          <bootstrap.Row className="py-2">
            <bootstrap.Col>
              {" "}
              <bootstrap.Form.Label htmlFor="receipt" className="lead py-2">
                Please upload an image of your purchase receipt. If you do not
                have a copy of your purchase receipt, please log into your
                account where you purchased the bed and obtain a copy.
              </bootstrap.Form.Label>
              <RUG
                rules={{
                  limit: 1,
                  size: 5000,
                }}
                accept={["jpg", "jpeg", "png", "gif"]}
                onWarning={(type, rules) => {
                  switch (type) {
                    case "accept":
                      return window.confirm(
                        `Invalid file type. Acceptable photo formats include ${rules.accept.join(
                          ","
                        )}`
                      );
                    case "limit":
                      return window.confirm(
                        `Only ${rules.limit} image allowed to be uploaded`
                      );

                    case "size":
                      return window.confirm(`max size <= ${rules.size} KB`);

                    default:
                  }
                }}
                onConfirmDelete={(currentImage, images) => {
                  // setImageValid(false);
                  return window.confirm("Are you sure you want to delete?");
                }}
                onChange={(images) => {
                  handleInputChange(images);
                  // setImageValid(true);
                }}
              />
              {!imageValid && (
                <bootstrap.Alert variant="danger" className="text-center">
                  Required
                </bootstrap.Alert>
              )}
            </bootstrap.Col>
          </bootstrap.Row>
          <bootstrap.Card className="border-custom">
            <bootstrap.Card.Body>
              <bootstrap.Row>
                <bootstrap.Col>
                  {/* Wall Type */}
                  <bootstrap.Form.Label htmlFor="wallType" className="lead">
                    To what type of wall is the Murphy bed installed?
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Select
                      className="text-center"
                      id="wallType"
                      {...register("wallType", { required: true })}
                    >
                      <option value="">Please Select</option>
                      <option value="Drywall with wood studs">
                        Drywall with wood studs
                      </option>
                      <option value="Drywall with metal studs">
                        Drywall with metal studs
                      </option>
                      <option value="Masonry/Cement">Masonry/Cement</option>
                      <option value="Not Installed">Not Installed</option>
                      <option value="Other">Other</option>
                    </bootstrap.Form.Select>
                  </bootstrap.InputGroup>
                  {errors.wallType && (
                    <bootstrap.Alert variant="danger" className="text-center">
                      Required
                    </bootstrap.Alert>
                  )}
                  {/* Wallt Type Other */}
                  {watchWallType === "Other" && (
                    <div>
                      <bootstrap.Form.Label
                        htmlFor="wallTypeOther"
                        className="lead"
                      >
                        Please Specify
                      </bootstrap.Form.Label>
                      <bootstrap.InputGroup className="mb-3">
                        <bootstrap.Form.Control
                          type="text"
                          id="wallTypeOther"
                          {...register("wallTypeOther", {
                            required: true,
                          })}
                        />
                      </bootstrap.InputGroup>
                      {errors.wallTypeOther && (
                        <bootstrap.Alert
                          variant="danger"
                          className="text-center"
                        >
                          Required
                        </bootstrap.Alert>
                      )}
                    </div>
                  )}
                </bootstrap.Col>
              </bootstrap.Row>

              {watchWallType !== "Not Installed" && (
                <bootstrap.Row>
                  <bootstrap.Col>
                    {/* Who Installed */}
                    <bootstrap.Form.Label
                      htmlFor="whoInstalled"
                      className="lead"
                    >
                      Who Installed the bed?
                    </bootstrap.Form.Label>
                    <bootstrap.InputGroup className="mb-3">
                      <bootstrap.Form.Select
                        className="text-center"
                        id="whoInstalled"
                        {...register("whoInstalled", { required: true })}
                      >
                        <option value="">Please Select</option>
                        <option value="Self Installed">Self Installed</option>
                        <option value=" Professional/Handyman">
                          Professional/Handyman
                        </option>
                        <option value="Other">Other</option>
                      </bootstrap.Form.Select>
                    </bootstrap.InputGroup>
                    {errors.whoInstalled && (
                      <bootstrap.Alert variant="danger" className="text-center">
                        Required
                      </bootstrap.Alert>
                    )}
                    {/* Wallt Type Other */}
                    {watchWhoinstalled === "Other" && (
                      <div>
                        <bootstrap.Form.Label
                          htmlFor="whoInstalledOther"
                          className="lead"
                        >
                          Please Specify
                        </bootstrap.Form.Label>
                        <bootstrap.InputGroup className="mb-3">
                          <bootstrap.Form.Control
                            type="text"
                            id="whoInstalledOther"
                            {...register("whoInstalledOther", {
                              required: true,
                            })}
                          />
                        </bootstrap.InputGroup>
                        {errors.whoInstalledOther && (
                          <bootstrap.Alert
                            variant="danger"
                            className="text-center"
                          >
                            Required
                          </bootstrap.Alert>
                        )}
                      </div>
                    )}
                  </bootstrap.Col>
                </bootstrap.Row>
              )}

              <bootstrap.Row>
                <p className="lead py-2">
                  If installed by a professional/handyman, please provide
                  his/her details below:
                </p>
                <p className="lead py-2">Name:</p>
                <bootstrap.Col>
                  {/* First Name */}
                  <bootstrap.Form.Label
                    htmlFor="professionalFirstName"
                    className="lead"
                  >
                    First Name
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Control
                      type="text"
                      id="professionalFirstName"
                      {...register("professionalFirstName", {
                        maxLength: 80,
                      })}
                    />{" "}
                  </bootstrap.InputGroup>
                </bootstrap.Col>
                <bootstrap.Col>
                  {/* Last Name */}
                  <bootstrap.Form.Label
                    htmlFor="professionalLastName"
                    className="lead"
                  >
                    Last Name
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Control
                      type="text"
                      //placeholder={t("step2.lastName")}
                      id="professionalLastName"
                      {...register("professionalLastName", {})}
                    />
                  </bootstrap.InputGroup>
                </bootstrap.Col>
              </bootstrap.Row>
              <bootstrap.Row>
                <bootstrap.Col>
                  {" "}
                  {/* Professional Phone */}
                  <bootstrap.Form.Label
                    htmlFor="professionalPhone"
                    className="lead"
                  >
                    Phone
                  </bootstrap.Form.Label>
                  <bootstrap.InputGroup className="mb-3">
                    <bootstrap.Form.Control
                      type="tel"
                      placeholder="XXXXXXXXXX"
                      id="phone"
                      {...register("professionalPhone", {
                        maxLength: 10,
                        pattern: /\d{10}/i,
                      })}
                    />
                  </bootstrap.InputGroup>
                  {errors.professionalPhone && (
                    <bootstrap.Alert variant="danger">
                      <p className="lead text-danger text-center">
                        Max 10 characters
                      </p>
                    </bootstrap.Alert>
                  )}
                </bootstrap.Col>
              </bootstrap.Row>
            </bootstrap.Card.Body>
          </bootstrap.Card>
          <bootstrap.Row className="pt-2">
            {!isSubmitting && (
              <bootstrap.Button
                className="btn btn-primary btn-lg pt-1 justify-content-center"
                type="submit"
                id="SubmitButton"
              >
                Submit
              </bootstrap.Button>
            )}
            {isSubmitting && (
              <bootstrap.Button
                className="btn btn-primary btn-lg pt-1 justify-content-center"
                variant="primary"
                disabled
              >
                <bootstrap.Spinner
                  as="span"
                  animation="border"
                  variant="status"
                  aria-hidden="true"
                ></bootstrap.Spinner>
              </bootstrap.Button>
            )}
          </bootstrap.Row>
        </bootstrap.Container>
      </bootstrap.Form>
    </div>
  );
};
